class CountryInfo {
    constructor(countryCode, regionCode) {
        this.countryCode = countryCode;
        this.regionCode = regionCode;
    }
}

// Function to get country and region codes and return them as an instance of LocationInfo
export function getCountryInfo() {
    const urlParams = new URLSearchParams(window.location.search);
    let country, region;

    if (urlParams.has("country")) {
        country = urlParams.get("country");
        if (urlParams.has("region")) {
            region = urlParams.get("region");
        } else {
            region = null;
        }
    } else {
        country = sessionStorage.getItem("country_code");
        region = sessionStorage.getItem("region_code");
    }

    return new CountryInfo(country, region);
}